const ThumbsUp = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 8.77598H16.764C17.1049 8.776 17.4401 8.86281 17.7378 9.02818C18.0355 9.19356 18.2859 9.43201 18.4651 9.72089C18.6444 10.0098 18.7465 10.3395 18.7619 10.6788C18.7773 11.0181 18.7054 11.3556 18.553 11.6594L15.053 18.6339C14.8869 18.9652 14.6314 19.2437 14.3152 19.4384C13.999 19.633 13.6347 19.736 13.263 19.7359H9.246C9.083 19.7359 8.92 19.7159 8.761 19.6761L5 18.7395M12 8.77598V3.79422C12 3.26572 11.7893 2.75887 11.4142 2.38516C11.0391 2.01146 10.5304 1.80151 10 1.80151H9.905C9.405 1.80151 9 2.20504 9 2.70321C9 3.41461 8.789 4.11006 8.392 4.7019L5 9.77234V18.7395M12 8.77598H10M5 18.7395H3C2.46957 18.7395 1.96086 18.5296 1.58579 18.1559C1.21071 17.7822 1 17.2753 1 16.7468V10.7687C1 10.2402 1.21071 9.73334 1.58579 9.35963C1.96086 8.98593 2.46957 8.77598 3 8.77598H5.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ThumbsUp;
